var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmilesWeeklyObjective = function SvgSmilesWeeklyObjective(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 108.653,
    viewBox: "0 0 133 108.653",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_229",
    "data-name": "Grupo 229",
    transform: "translate(-113.5 -115.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ILUSTRA",
    transform: "translate(55.305 -100.187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1472",
    "data-name": "Ret\\xE2ngulo 1472",
    width: 43.72,
    height: 23.075,
    transform: "translate(103.411 277.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_811",
    "data-name": "Caminho 811",
    d: "M20.4,2.167a30.992,30.992,0,1,1-17.454,40.2A31,31,0,0,1,20.4,2.167ZM31.774,31H12.9a18.873,18.873,0,1,0,37.745,0H31.774Z",
    transform: "translate(92.921 250.003)",
    fill: "#f5b827",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_211443840",
    d: "M23.638,24.734c9.916,0,17.957,2.01,17.957,4.488s-8.041,4.488-17.957,4.488S5.681,31.7,5.681,29.222,13.722,24.734,23.638,24.734Z",
    transform: "translate(101.058 291.024)",
    fill: "rgba(31,26,23,0.2)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "raios",
    transform: "translate(115 117.395)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_38",
    "data-name": "Linha 38",
    y1: 22.451,
    transform: "translate(65.261 0)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_39",
    "data-name": "Linha 39",
    y1: 19.443,
    x2: 11.225,
    transform: "translate(86.501 8.839)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_40",
    "data-name": "Linha 40",
    y1: 11.225,
    x2: 19.441,
    transform: "translate(101.98 32.726)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_41",
    "data-name": "Linha 41",
    x2: 22.45,
    transform: "translate(107.55 65.261)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_42",
    "data-name": "Linha 42",
    x2: 19.443,
    y2: 11.224,
    transform: "translate(101.718 86.502)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_46",
    "data-name": "Linha 46",
    x1: 19.442,
    y2: 11.225,
    transform: "translate(8.578 86.049)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_47",
    "data-name": "Linha 47",
    x1: 22.45,
    transform: "translate(0 64.739)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_48",
    "data-name": "Linha 48",
    x1: 19.442,
    y1: 11.225,
    transform: "translate(8.839 32.274)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_49",
    "data-name": "Linha 49",
    x1: 11.225,
    y1: 19.441,
    transform: "translate(32.726 8.578)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmilesWeeklyObjective, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smiles_weekly_objective.9646a9cb.svg";
export { ForwardRef as ReactComponent };